<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div class="content">
  <div class="current-matches mat-elevation-z10">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Current matches</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-qualification-matches
          [tournamentId]="tournamentId()"
          [qualificationMatches]="runningMatches()"
          [viewOnly]="true"
          [showEmptyMessage]="false"
        ></app-qualification-matches>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="next-matches mat-elevation-z8">
    <mat-card class="h-100">
      <mat-card-header>
        <mat-card-title>Next matches </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-qualification-matches
          [tournamentId]="tournamentId()"
          [qualificationMatches]="nextMatches()"
          [viewOnly]="true"
          [sortByCurrentlyPlaying]="true"
          [currentlyPlayingTeamIds]="currentlyPlayingTeamIds()"
        ></app-qualification-matches>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="score-table mat-elevation-z8" #scoreContainer>
    <app-tournament-score-table
      [scoreDtos]="scoreDtos()"
      [viewOnly]="true"
    ></app-tournament-score-table>
  </div>
  <div class="previous-matches mat-elevation-z8">
    <mat-card class="h-100">
      <mat-card-header>
        <mat-card-title> Previous matches </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-qualification-matches
          [tournamentId]="tournamentId()"
          [qualificationMatches]="playedMatches()"
          [viewOnly]="true"
          [showEmptyMessage]="false"
          [sortPreviousMatchesDesc]="true"
          [enableScrolling]="false"
        ></app-qualification-matches>
      </mat-card-content>
    </mat-card>
  </div>
</div>
